export default __webpack_public_path__ + "static/no-results-04b3fd605d752cc17a1a7650fb46dddf5e7aeae1e2ecc3821ac20483716dfa08.png";